import {Component} from '@angular/core';
import {Events, NavController, NavParams, ViewController} from 'ionic-angular';
import {HttpClient} from "@angular/common/http";
import {ApiErrorHandlerProvider} from "../../providers/api-error-handler/api-error-handler";

/**
 * Generated class for the NoShowModalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-no-show-modal',
    templateUrl: 'no-show-modal.html',
})
export class NoShowModalPage {

    barber: any;
    booking: any;
    action: any;
    loading: boolean;
    errors: {};

    constructor(public viewCtrl: ViewController, public navParams: NavParams, public events: Events, private http: HttpClient, private apiErrorHandler: ApiErrorHandlerProvider) {
        this.barber = navParams.get('barber');
        this.booking = navParams.get('booking');
        this.action = navParams.get('action');
    }

    noShow() {
        this.loading = true;

        this.http.post(`/bookings/${this.booking.id}/no-show`, {}).subscribe((booking) => {
            this.errors = {};
            this.loading = false;
            this.viewCtrl.dismiss(booking);
        }, error => {
            this.loading = false;
            this.errors = this.apiErrorHandler.handleError(error);
        }, () => {

        });
    }

    cancelBooking() {
        this.loading = true;

        this.http.post(`/bookings/${this.booking.id}/cancel`, {}).subscribe((booking) => {
            this.errors = {};
            this.loading = false;
            this.viewCtrl.dismiss(booking);
        }, error => {
            this.loading = false;
            this.errors = this.apiErrorHandler.handleError(error);
        }, () => {

        });
    }

    closeModal() {
        this.viewCtrl.dismiss();
    }

}



// WEBPACK FOOTER //
// ./src/pages/no-show-modal/no-show-modal.ts